import React, { Component } from 'react'

import { Navbar, SidebarComponent } from '../../_components'
import UserHelper from '../../_helpers/UserHelper';

export class UnauthorisedPage extends Component {
    async componentDidMount(){
        const manager = UserHelper.getUserManager();
        const user = await manager.getUser();
        if (!user || user.expired){
            manager.removeUser().then(function(){
                manager.signinRedirect();
            });
        }
    }

    render() {
        return (
            <div>
                <Navbar handleClick={(event) => console.log(event.target)}/>
                <SidebarComponent content={this.renderPage()}/>
            </div>
        )
    }

    renderPage() {
        return (
            <div>
                <h1>401 - Unauthorised</h1>
            </div>
        )
    }
}
